import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { saveEntity, deleteEntity } from '../../redux/vCommTranBonuReducer';
import { showConfirm, showWarning } from '../../redux/msgReducer';

import Button from '@material-ui/core/Button';

export default function CommBonusShareDetailBottomButtons() {
    const dispatch = useDispatch();
    const history = useHistory();

    const { workingEntity } = useSelector(state => {
        return state.vCommTranBonus;
    });

    const { jWTClaimModel: { Creds } } = useSelector(state => {
        return state.auth;
    });

    const navClicked = (path) => {
        history.push(path);
    };

    const confirmDelete = () => {
        const fnConfirm = (_) => { dispatch(deleteEntity(history)); };
        dispatch(showConfirm("確定刪除？", fnConfirm));
    };

    return <div style={{ textAlign: 'center' }} className="mt-5">
        {Creds.includes("SAVING") && <React.Fragment>
            <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { dispatch(saveEntity()); }}>儲存獎金分成</Button>
            {workingEntity && !workingEntity.isNew() && <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { confirmDelete(); }}>刪　除</Button>}
        </React.Fragment>}
        <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { navClicked("/commBonusShare"); }}>返回列表</Button>
    </div>
}
